var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEco = function SvgEco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ECO_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h40v40H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ECO_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#402C22",
    d: "M18.75 35c-.92 0-1.84-.11-2.77-.32-.94-.2-1.89-.5-2.86-.89.33-3.36 1.31-6.5 2.92-9.42q2.415-4.38 6.21-7.71c-3.06 1.56-5.71 3.61-7.94 6.17-2.24 2.55-3.8 5.47-4.69 8.75-.11-.08-.21-.17-.31-.27L9 31c-1.31-1.31-2.3-2.77-2.98-4.38Q5 24.205 5 21.58c0-1.89.37-3.7 1.12-5.42s1.79-3.25 3.13-4.58c2.25-2.25 5.16-3.72 8.75-4.4 3.58-.68 8.61-.74 15.08-.18.5 6.63.42 11.7-.25 15.18-.67 3.49-2.11 6.34-4.33 8.57-1.37 1.36-2.89 2.41-4.57 3.14-1.68.74-3.41 1.11-5.18 1.11"
  }))));
};
export default SvgEco;